import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SignUpModule} from './sign-in/sign-up.module';
import {SettingsModule} from './settings/settings.module';
import {provideTranslateService, TranslatePipe} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {HelpingHandComponent} from './helping-hand/helping-hand.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SpinnerModule} from './spinner/spinner.module';
import {PurchaseComponent} from './purchase/purchase.component';
import {MatCardModule} from '@angular/material/card';
import {RatingDialogModule} from './rating/rating-dialog.module';


@NgModule({
  declarations: [
    AppComponent,
    HelpingHandComponent,
    PurchaseComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SignUpModule,
    SettingsModule,
    SpinnerModule,
    MatCardModule,
    RatingDialogModule,
    TranslatePipe,
  ],
  providers: [
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
        enforceLoading: false,
        useHttpBackend: false
      })
    })
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {
}


